import styled from "styled-components";

export const Container = styled.div`
    width: 472px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 32px;
`;

export const Title = styled.div`
    color: ${({ theme }) => theme.orangeWarning};
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: 0.07px;

    display: flex;
    align-items: center;
    gap: 8px;
`;

export const Text = styled.div`
    color: ${({ theme }) => theme.gray800};
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.14px;
`;
